import Layout from "@/layout/layout";
const reviewQuotation = {
  path: "/reviewQuotation",
  component: Layout,
  redirect: "noRedirect",
  name: "审单报价",
  children: [
    {
      path: "ruleConfig",
      component: () => import("@/views/reviewQuotation/ruleConfig/index"),
      name: "审单机型配置",
      meta: { title: "审单规则配置", noCache: true },
    },
    {
      path: "personnelConfig",
      component: () => import("@/views/reviewQuotation/personnelConfig/index"),
      name: "审单人员配置",
      meta: { title: "审单人员配置", noCache: true },
    },
    {
      path: "pendingOrder",
      component: () => import("@/views/reviewQuotation/pendingOrder/index"),
      name: "待审订单",
      meta: { title: "待审订单", noCache: true },
    },
    {
      path: "channelCost",
      component: () => import("@/views/reviewQuotation/channelCost/index"),
      name: "渠道费用设置",
      meta: { title: "渠道费用设置", noCache: true },
    },
    {
      path: "examinedOrder",
      component: () => import("@/views/reviewQuotation/examinedOrder/index"),
      name: "已审订单",
      meta: { title: "已审订单", noCache: true },
    },
    {
      path: "setFeeTemplate",
      component: () =>
        import("@/views/reviewQuotation/channelCost/setFeeTemplate/index"),
      name: "费用模板",
      meta: { title: "费用模板", noCache: true },
    },
    {
      path: "examineStatistics",
      component: () =>
        import("@/views/reviewQuotation/examineStatistics/index"),
      name: "审单数据",
      meta: { title: "审单数据", noCache: true },
    },
    {
      path: "queryDetails",
      component: () => import("@/views/reviewQuotation/queryDetails/index"),
      name: "串号查询明细",
      meta: { title: "串号查询明细", noCache: true },
    },
    {
      path: "goodsPriceSet",
      component: () => import("@/views/reviewQuotation/goodsPriceSet/index"),
      name: "机型出货价配置",
      meta: { title: "机型出货价配置", noCache: true },
    },
    {
      path: "monitorQuotation",
      component: () => import("@/views/reviewQuotation/monitorQuotation/index"),
      name: "监控报价",
      meta: { title: "监控报价", noCache: true },
    },
    {
      path: "quickData",
      component: () => import("@/views/reviewQuotation/quickData/index"),
      name: "快捷报价数据",
      meta: { title: "快捷报价数据", noCache: true },
    },
    {
      path: "quickOrder",
      component: () => import("@/views/reviewQuotation/quickOrder/index"),
      name: "快捷报价订单",
      meta: { title: "快捷报价订单", noCache: true },
    },
    {
      path: "quickQuoteConfig",
      component: () => import("@/views/reviewQuotation/quickQuoteConfig/index"),
      name: "快捷报价配置",
      meta: { title: "快捷报价配置", noCache: true },
    },
    {
      path: "systemWarning",
      component: () => import("@/views/reviewQuotation/systemWarning/index"),
      name: "系统预警",
      meta: { title: "系统预警", noCache: true },
    },
    {
      path: "referencePrice",
      component: () => import("@/views/RecallOrder/referencePrice/index"),
      name: "参考价",
      meta: { title: "参考价", noCache: true },
    },
  ],
};

export default reviewQuotation;
